//require('dotenv').config();
// export const SERVER_ADDRESS= "http://localhost:3000/graphql";
// export const WS_SERVER_ADDRESS='ws://localhost:3000/graphql';

export const SERVER_ADDRESS= "https://launch.artyfact.game/graphql";
export const WS_SERVER_ADDRESS='wss://launch.artyfact.game/graphql';
export const SITE_ADDRESS = "https://launch.artyfact.game";
